import { Reveal } from "./Reveal";
import { Formline } from "./Formline";

const CHAPTERS = [
  {
    n: "01",
    title: "Indigenous-Owned & Proud",
    body: "We are 100% Indigenous-owned. Our heritage isn't a badge — it's the foundation of how we operate, hire and serve every community we protect.",
  },
  {
    n: "02",
    title: "Respect Guides Every Post",
    body: "We carry our cultural values onto every site: respect for people, for the land, and for the responsibility of keeping others safe. It shapes conduct, communication and care.",
  },
  {
    n: "03",
    title: "Community Before Contract",
    body: "Security is a relationship of trust. We invest in the neighbourhoods and businesses we serve, building long-term partnerships rooted in accountability.",
  },
];

export const Values = () => (
  <section id="values" data-testid="values-section" className="relative py-24 md:py-32 bg-[color:var(--surface)] border-y border-white/10 overflow-hidden">
    <Formline className="absolute -right-20 top-10 w-[420px] h-[420px]" opacity={0.05} />
    <Formline className="absolute -left-24 bottom-0 w-[360px] h-[360px] rotate-12" opacity={0.04} />

    <div className="relative mx-auto max-w-7xl px-5 md:px-8">
      <Reveal className="max-w-3xl">
        <span className="text-xs font-bold uppercase tracking-[0.24em] text-[color:var(--primary-text)]">
          Our Values
        </span>
        <h2 className="mt-5 font-display text-4xl md:text-6xl tracking-tight leading-none">
          Guarding is a duty. Ours is{" "}
          <span className="font-editorial italic">cultural</span>.
        </h2>
      </Reveal>

      <div className="mt-16 space-y-10 md:space-y-4">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.08}>
            <div
              data-testid={`value-chapter-${c.n}`}
              className="relative grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-start py-8 border-t border-white/10 group"
            >
              <div className="md:col-span-3 relative">
                <span className="font-display text-7xl md:text-8xl leading-none text-white/[0.06] group-hover:text-[color:var(--primary)]/20 transition-colors duration-500 select-none">
                  {c.n}
                </span>
              </div>
              <h3 className="md:col-span-4 font-display text-2xl md:text-3xl tracking-tight">
                {c.title}
              </h3>
              <p className="md:col-span-5 text-lg text-secondary leading-relaxed">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
